<script setup>
import PlaylistOptions from '@components/playlists/playlist-options'

const props = defineProps({
    playlist: {
        type: Object,
        default: () => {},
    },
    type: {
        type: String,
        default: 'playlists',
    },
})

const route = { name: props.type === 'charts' ? 'browse/charts' : 'browse/playlists' }
</script>

<template>
    <div>
        <div>
            <BaseLink :to="{ name: route.name, params: { id: playlist.id } }">
                <BaseResourceCover
                    :image-resource="playlist"
                    :media-resource="playlist"
                    image-type="revisions_album_art"
                    media-type="playlist"
                    radius="card"
                >
                    <template #secondaryActions>
                        <div>
                            <PlaylistOptions :playlist="playlist" />
                        </div>
                    </template>
                </BaseResourceCover>
            </BaseLink>
        </div>
        <BaseLink
            v-if="playlist && playlist.revisions_title"
            class="title"
            :to="{ name: route.name, params: { id: playlist.id } }"
        >
            <div class="title">
                {{ playlist.revisions_title }}
            </div>
        </BaseLink>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.title {
    @extend %contentTitleM;

    margin-top: $size-grid-padding;
    line-height: 24px;
    text-align: center;
}
</style>
